import React, { useState } from 'react';
import { MotionButton, MotionCard, FadeInSection } from '../ui/MotionPrimitives';

const faqs = [
  {
    question: 'What are your core service areas?',
    answer:
      'We specialize in strategic property acquisition, development advisory, and portfolio management across key markets in the UAE and the USA, focusing on long-term wealth creation.',
  },
  {
    question: 'How do we start working together?',
    answer:
      'We begin with a consultation to understand your goals, risk profile, and preferred markets, then craft a tailored investment roadmap.',
  },
  {
    question: 'What is your approach to risk and due diligence?',
    answer:
      'Every opportunity is screened through rigorous financial modelling, on-the-ground verification, and legal due diligence to protect your capital.',
  },
  {
    question: 'Do you assist with property management after purchase?',
    answer:
      'Yes. Our team and partners can support leasing, management, and reporting to keep your portfolio performing over the long term.',
  },
];

const Newsletter: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleItem = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };
  return (
    <FadeInSection className="w-full bg-white py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="grid gap-10 md:grid-cols-2 md:items-stretch">
          {/* Left: Call-to-action card */}
          <div className="flex h-full flex-col justify-between rounded-3xl bg-[#D88546] px-7 py-9 text-white shadow-[0_18px_40px_rgba(15,23,42,0.28)] md:px-9 md:py-10">
            <div>
              <h2 className="text-2xl font-semibold md:text-3xl">
                Stay Ahead of the Market
              </h2>
              <p className="mt-3 text-sm text-white/85 md:text-base">
                Get curated insights on prime UAE and US real estate opportunities, delivered straight to your inbox.
              </p>
            </div>

            <div className="mt-8">
              <div className="flex items-center gap-3 rounded-full bg-white/10 px-4 py-3 text-sm">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-lg">
                  ✉
                </span>
                <span className="text-white/90">
                  Can't find the right opportunity yet? Let us keep you updated.
                </span>
              </div>

              <MotionButton
                type="button"
                className="mt-5 inline-flex items-center justify-center rounded-full bg-white px-7 py-2.5 text-sm font-semibold text-[#D88546] shadow-sm transition-colors hover:bg-gray-100"
              >
                Contact Our Team
              </MotionButton>
            </div>
          </div>

          {/* Right: FAQ-style content */}
          <div className="flex flex-col gap-6">
            <div>
              <h3 className="text-[26px] font-semibold text-black md:text-[30px]">
                Your Questions, Answered
              </h3>
              <p className="mt-1 text-sm text-black/60 md:text-[15px]">
                Find quick answers to common questions about investing with Hogar Dorado House and our advisory process.
              </p>
            </div>

            <div className="space-y-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;

                return (
                  <MotionCard
                    key={item.question}
                    onClick={() => toggleItem(index)}
                    className={`w-full rounded-2xl border bg-white text-left transition-colors ${
                      isOpen
                        ? 'border-[#D88546]/60 bg-white shadow-[0_16px_30px_rgba(15,23,42,0.16)]'
                        : 'border-gray-200 hover:border-[#D88546]/70 hover:bg-gray-50'
                    }`}
                  >
                    <div className="flex items-start justify-between gap-4 px-4 py-3 md:px-5 md:py-4">
                      <div>
                        <h4
                          className={`text-sm md:text-[15px] ${
                            isOpen ? 'font-semibold text-[#D88546]' : 'font-medium text-black/85'
                          }`}
                        >
                          {item.question}
                        </h4>
                        {isOpen && (
                          <p className="mt-2 text-sm leading-relaxed text-black/70 md:text-[15px]">
                            {item.answer}
                          </p>
                        )}
                      </div>
                      <span
                        className={`mt-1 inline-flex h-7 w-7 items-center justify-center rounded-full text-sm font-semibold ${
                          isOpen ? 'bg-[#D88546]/10 text-[#D88546]' : 'bg-gray-100 text-black/70'
                        }`}
                      >
                        {isOpen ? '−' : '+'}
                      </span>
                    </div>
                  </MotionCard>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default Newsletter;
